import React, { ReactElement } from "react"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
import strings from "../../localization/strings"
import { grey700, grey600 } from "material-ui/styles/colors"
export interface IAlertDialogProps {
	open: boolean
	title?: string
	buttonTitle?: string
	content: string | string[]
	subContent?: string | string[]
	icon?: ReactElement
	close?(): void
}

const AlertDialog = (props: IAlertDialogProps) => {
	return (
		<Dialog
			autoScrollBodyContent
			actions={props.close ? [
				<FlatButton
					label={props.buttonTitle ? props.buttonTitle : strings.OK}
					primary={true}
					keyboardFocused={true}
					onClick={props.close}
				/>
			] : []}
			modal={true}
			open={props.open}
			onRequestClose={props.close}
			style={{ zIndex: 10000 }}
		>
			<div style={{ display: "flex" }}>
				{props.icon &&
					<div>{props.icon}</div>
				}
				<div style={{ marginLeft: props.icon ? 20 : 0 }}>
					{props.title &&
						<div style={{ color: grey700, fontSize: 20, marginBottom: 20 }}>
							{props.title}
						</div>
					}
					<div style={{ color: grey600, fontSize: 15, whiteSpace: "pre-line" }}>
						{Array.isArray(props.content) ?
							<ul>
								{props.content.map((i, index) =>
									<li key={index}>{i}</li>
								)}
							</ul> :
							props.content
						}
					</div>
					{props.subContent &&
						<div style={{ color: grey600, fontSize: 13, whiteSpace: "pre-line" }}>
							{Array.isArray(props.subContent) ?
								<ul>
									{props.subContent.map((i, index) =>
										<li key={index}>{i}</li>
									)}
								</ul> :
								props.subContent
							}
						</div>
					}
				</div>
			</div>
		</Dialog>
	)
}

export default AlertDialog
